import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FeaturedSection = ({ workouts, onStartWorkout }) => {
  if (!workouts || workouts?.length === 0) return null;

  const featured = workouts?.[0];

  return (
    <div className="bg-gradient-to-br from-primary to-secondary rounded-xl overflow-hidden shadow-xl mb-6 lg:mb-8">
      <div className="grid lg:grid-cols-2 gap-0">
        <div className="relative aspect-[16/9] lg:aspect-auto overflow-hidden">
          <Image
            src={featured?.image}
            alt={featured?.imageAlt}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent lg:hidden" />
        </div>

        <div className="p-6 md:p-8 lg:p-10 flex flex-col justify-center text-primary-foreground">
          <div className="flex items-center gap-2 mb-3">
            <Icon name="Star" size={20} color="var(--color-warning)" fill="var(--color-warning)" />
            <span className="text-sm font-semibold caption">FEATURED WORKOUT</span>
          </div>

          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold mb-3 lg:mb-4">
            {featured?.title}
          </h2>

          <p className="text-base md:text-lg text-primary-foreground/90 mb-4 lg:mb-6 line-clamp-3">
            {featured?.description}
          </p>

          <div className="flex flex-wrap gap-4 mb-6">
            <div className="flex items-center gap-2">
              <Icon name="Clock" size={18} color="var(--color-primary-foreground)" />
              <span className="text-sm whitespace-nowrap">{featured?.duration}</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Dumbbell" size={18} color="var(--color-primary-foreground)" />
              <span className="text-sm whitespace-nowrap">{featured?.exercises} exercises</span>
            </div>
            <div className="flex items-center gap-2">
              <Icon name="Flame" size={18} color="var(--color-accent)" />
              <span className="text-sm whitespace-nowrap">{featured?.calories} cal</span>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              variant="default"
              size="lg"
              iconName="Play"
              iconPosition="left"
              onClick={() => onStartWorkout(featured)}
              className="bg-accent hover:bg-accent/90 text-accent-foreground"
            >
              Start Workout
            </Button>
            <Button
              variant="outline"
              size="lg"
              iconName="Info"
              iconPosition="left"
              onClick={() => featured?.onPreview(featured)}
              className="border-primary-foreground/20 text-primary-foreground hover:bg-primary-foreground/10"
            >
              Learn More
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedSection;